var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLikes = function SvgLikes(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86788 16.0066C9.23532 16.3373 9.78262 16.3333 10.1456 15.9977C11.927 14.3505 16.8407 9.54373 16.8407 6.64065C16.8407 4.80165 15.7281 2.91992 13.3064 2.91992C11.3429 2.91992 9.51031 5.34502 9.51031 5.34502C9.51031 5.34502 7.67771 2.91992 5.71421 2.91992C3.29257 2.91992 1.98357 4.81575 1.98357 6.64065C1.98357 9.54896 7.0471 14.3678 8.86788 16.0066Z",
    stroke: "black",
    strokeWidth: 1.1
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLikes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/likes.0734ce561a9e5c5f54f35d32a259763f.svg";